import Loader from './Loader';

// Constants
import { SIZES } from './spinner.sizes';
export { SIZES };
export default Loader;